type GuardEntry = {
  isDirty: () => boolean
  requestConfirm: (proceed: () => void) => void
}

let entry: GuardEntry | null = null

export const navigationGuard = {
  register(e: GuardEntry) {
    entry = e
  },
  unregister() {
    entry = null
  },
  /**
   * Chama proceed() imediatamente se não há alterações pendentes.
   * Se houver, delega a confirmação ao componente registrado.
   * Retorna true se navegou direto, false se foi bloqueado para confirmação.
   */
  attempt(proceed: () => void): boolean {
    if (!entry || !entry.isDirty()) {
      proceed()
      return true
    }
    entry.requestConfirm(proceed)
    return false
  },
}
